import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import createReducer from "./CombineReducers";
import { createOffline } from "@redux-offline/redux-offline"; //Anil Addition
import offlineConfig from "@redux-offline/redux-offline/lib/defaults"; //anil Addition
import { persistReducer } from "redux-persist"; //anil Addition
import Storage from "redux-persist/lib/storage"; //anil Addition

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
  }
}

function configureStore(initialState = {}) {
  //Anil Addition Start
  const {
    middleware: offlineMiddleware,
    enhanceReducer: offlineEnhanceReducer,
    enhanceStore: offlineEnhanceStore
  } = createOffline({
    ...offlineConfig,
    persist: () => false
  });

  const persistConfig = {
    key: "root",
    storage: Storage

  };
  //Anil Addition - End
  let composeEnhancers = compose;
  const reduxSagaMonitorOptions = {};

  // If Redux Dev Tools and Saga Dev Tools Extensions are installed, enable them
  /* istanbul ignore next */
  if (process.env.NODE_ENV !== "production" && typeof window === "object") {

    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
  }

  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);

  // Create the store with two middlewares
  // 1. sagaMiddleware: Makes redux-sagas work
  const middlewares: Array<any> = [sagaMiddleware];

  if (process.env.NODE_ENV !== "production" && typeof window === "object") {

  }

  middlewares.push(offlineMiddleware); //Anil Addition

  const enhancers = [offlineEnhanceStore, applyMiddleware(...middlewares)]; //Anil Addition



  const store: any = createStore(

    persistReducer(persistConfig, offlineEnhanceReducer(createReducer())), //Anil addition
    initialState,
    composeEnhancers(...enhancers)
  );

  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry

  return store;
}
export const store = configureStore();
